import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions, YesNoSelect, Select } from '../../common/components/formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t, territories }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<YesNoSelect name='isOnline' label={t('WeeklyProgram_IsOnline')} emptyOptionLabel={t('Common_All')} />
						</Col>
						<Col sm={6}>
							<Select name='territoryId' label={t('WeeklyProgram_Territory')} data={territories} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='centerName' component={Input} label={t('WeeklyProgram_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='contactPerson' component={Input} label={t('WeeklyProgram_ContactPerson')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='address' component={Input} label={t('WeeklyProgram_Address')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'weeklyProgramFilter' })(Filter);